import axios from 'axios';
import config from '../config';

const apiClient = axios.create({
  baseURL: config.apiBase,
  responseType: 'json',
  method: 'post',
});

export default apiClient;
